enum BillingStrategy {
  subscription = "SUBSCRIPTION",
  lifetime = "LIFETIME",
}

export default BillingStrategy;
